export default {
    translations: { // Mesmo valor usado nas configurações (defaultNS)
      home: {
        message: 'Olá Mundo!'
      },
      dashboard: {
        title: 'Monitoramento das Infecções Respiratórias Atenção Primária em Saúde (APS) no Brasil',
        subtitle: 'Visão Geral dos Atendimentos por Infecções de Via Aérea Superior (Gripais)',
        queda: 'Queda',
        estavel: 'Estável',
        alta : 'Alta',
        data : 'Data',
        cidade : 'Município',
        populacao: 'População',
        atencao: 'Atenção',
        aviso: 'Aviso',
        titulo_mapa_taxa_crescimento: 'Taxa de crescimento dos Atendimentos Gripais (Média Móvel)',
        titulo_mapa_atendimentos_excedentes : 'Atendimentos Gripais Excedentes',
        legenda_mapa_taxa_crescimento: 'Taxa de Crescimento',
        legenda_mapa_atendimentos_excedentes: 'Atendimentos Excedentes',
        graficos: {
          titulo_mm: 'Razão de Atendimentos Gripais',
          legenda_mm: {
            1: 'Média Móvel',
            2: 'Razão (Gripais / Total de atendimentos)'
          },
          titulo_variacao_mm : 'Taxa de crescimento da Razão dos Atendimentos Gripais (Média Móvel)',
          titulo_atendimento_gripais : 'Atendimentos Gripais na APS',
          titulo_atendimento_totais : 'Total de Atendimentos na APS',
          titulo_excesso : 'Excesso de atendimentos gripais do limite esperado',
          titulo_limite : 'Limite Esperado dos atendimentos gripais',
        },
        table: {
          col1: 'Município​',
          col2: 'População',
          col3: 'Taxa de Crescimento (Razão Gripais) %',
          col4: 'Excesso  de encontros (Gripais)',
          col5: 'Limite Superior Esperado  de atendimento (Gripais)',
          col6: 'Razão de Atendimentos Gripais',
          col7: 'Atendimentos Gripais',
          col8: 'Atendimentos Totais',
        },
        todos: 'Todos'
      }
    }
  }